import { getImageUrl } from '@koob/utils';

interface TripDayHotelFlags {
  hotelIsNotDistributed: boolean;
  suggestedHotelIds: any[];
  hotelImage: string;
  isIncludedHotel: any;
  nights: number;
  isFirstInGroup: boolean;
  isMinStayUnmet: boolean;
}

// Split out of useTripDayHotelData (US-062) to stay under the package's
// max-lines-per-function cap — plain derived fields, no hook of their own.
export function getTripDayHotelFlags({
  dayIndex,
  day,
  hotel,
  hotelGroup,
  program,
}: {
  dayIndex: number;
  day: any;
  hotel: any;
  hotelGroup: any;
  program: any;
}): TripDayHotelFlags {
  const hotelIsNotDistributed =
    day?.hotelIsAccessible === false || hotel?.isAccessible === false;

  const suggestedHotelIds = [
    program?.accomodationHotel?.id,
    ...(program?.alternativeHotels ?? []).map((h: any) => h.id),
  ].filter(Boolean);

  const hotelImage = getImageUrl(hotel) ?? '/img/hotel-image-placeholder.png';

  const isIncludedHotel =
    hotel?.id &&
    program?.isIncludedAccomodation &&
    (program?.accomodationHotel?.id === hotel?.id?.toString() ||
      program?.alternativeHotels?.some(
        ({ id }: any) => id === hotel?.id?.toString(),
      ));

  const nights = hotelGroup?.nights || 1;
  const isFirstInGroup = hotelGroup?.startDayIndex === dayIndex;

  // A hotel short of its binding minimum stay can be placed on the trip, so
  // the day row has to keep saying so for as long as the stay is too short.
  const isMinStayUnmet = nights < Number(hotel?.minimumStay ?? 0);

  return {
    hotelIsNotDistributed,
    suggestedHotelIds,
    hotelImage,
    isIncludedHotel,
    nights,
    isFirstInGroup,
    isMinStayUnmet,
  };
}
